import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { createNewFlexSectionData } from '@/widgets/FlexSection/create';
import { FlexSectionDirection } from '@/widgets/FlexSection/types';
import { createNewImageData } from '@/widgets/Image/create';
import { createNewTextData } from '@/widgets/Text/create';

export function createNewCombinedTitleData(content: string): ManifestInitializedProps {
  const id = genRandId();

  const [imageData] = createNewImageData();
  const [textData] = createNewTextData(content, 'header', false);

  const [horizontalSectionData] = createNewFlexSectionData(FlexSectionDirection.row, [
    { id: imageData.id, width: 60, height: 60, span: 1, column: 0, isDeletable: false, isDraggable: false },
    { id: textData.id, width: 300, height: 'auto', isDeletable: false, isDraggable: false }
  ]);
  const { id: horizontalSectionId } = horizontalSectionData;
  const childrenArray = new Y.Array();
  childrenArray.push([horizontalSectionId]);

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.CombinedTitle],
        ['children', childrenArray],
        ['style', new Y.Map()]
      ])
    },
    horizontalSectionData,
    imageData,
    textData
  ];
}
